/*
 * @FilePath     : /es-package/packages/es-mpx-usex/lib/pre.js
 * @Author       : LiYang
 * @Date         : 2021-12-07 11:07:53
 * @LastEditTime: 2023-08-25 03:50:44
 * @LastEditors: liuziwei
 * @Description  : 预发环境动态替换规则
 */

import getEnv from './env'
const reg = /^[\^|\/]/
const PRE_REG = /(?:\/pre-release-)(\w+)/
const isPre = PRE_REG.test(window.location.pathname)
const proxy = isPre ? __PROXY_TABLE__TEST__ :  __PROXY_TABLE__; 
const isOffline = !__OFFLINE__
const whiteList =  Object.keys(proxy).map(key => new RegExp(key));

// const PRE_REG = /(?:\/pre)(\w+)/

const replace = (path, pre) => {
 
  const match = whiteList.find(reg => reg.test(path));
  if (match) {
    //pre-release-17
    const prefix = path.match(match)
    const env = pre < 10 ? '0' + pre : pre
    // if (prefix) {
    //   path = path.replace(match, (pre ? `/pre${env}` : '').concat('-es.xiaojukeji.com'))
    // }
  }

  return path;
}

const proxyTable = Object.keys(proxy).map(key => {
  return {
    url: proxy[key].replace(/\/$/, ''),
    reg: new RegExp(reg.test(key) ? key : '^(' + key + '\/)')
  }
})

export default (config) => {
  const target = proxyTable.find(item => item.reg.test(config.url))
    // target====? {url: "https://travel.xiaojukeji.com", reg: /^/travel/}
  // target====? {url: "https://travel.xiaojukeji.com", reg: /^/travel/}
  return getEnv().then(async (env) => {
    // -1为线上不需要替换
    if (env && String(env) !== '-1') {
      if (target && !PRE_REG.test(target.url)) {
        config.url = replace(config.url, env)
      }
    }
    // 非地本环境用线上接口域名
    // 本地环境且是香港域名用线上接口域名，不再用本地代理方式
    if (target && (isOffline)) {
      config.url = config.url.replace(target.reg, target.url)
    }
    return config
  }) 
}
